import z from 'zod';

import { INVESTMENT_PROGRAMME_FORM_FIELDS } from './types';

export const InvestmentProgrammeFormShape = z.object({
	[INVESTMENT_PROGRAMME_FORM_FIELDS.mip_id]: z.string(),
});
